<template>
    <div class="fee-card" :class="{ 'fee-card__selected-bordered': isSelected }" @click="handleSelect">
        <div v-if="isRecommended" class="fee-card__recommended">Recomendado</div>
        <div class="fee-card__content">
            <div class="fee-card__tax">
                <b-field class="fee-card__field">
                    <b-radio v-model="isSelected" class="fee-card__label"
                        :native-value="true" @click.stop></b-radio>
                </b-field>
                <span>Taxa de {{ fee }}%</span>
            </div>
            <hr class="fee-card__divider" />
            <p class="fee-card__days">
                Recebimento em {{ days }} dias úteis
            </p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FeeCard',
    props: {
        id: {
            type: String,
            required: true
        },
        fee: {
            type: [String, Number],
            required: true
        },
        days: {
            type: [String, Number],
            required: true
        },
        isSelected: {
            type: Boolean,
            required: true,
            default: false
        },
        isRecommended: {
            type: Boolean,
            required: true,
            default: false
        }
    },
    methods: {
        handleSelect() {
            this.$emit('select', this.id)
        }
    }
}
</script>

<style lang="scss" scoped>
.fee-card {
    width: 100%;
    background-color: #fff;
    border-radius: 8px;
    border: 1px solid #D4DBE3;
    position: relative;
    cursor: pointer;

    &__selected-bordered {
        border: 1px solid #E583A2;
    }

    &__content {
        padding: 32px 24px 24px 24px;
    }

    &__tax {
        display: flex;
        flex-direction: row;
        justify-items: flex-start;
        align-items: flex-start;

        font-weight: 700;
        font-size: 16px;
        color: #4E637B;
    }

    &__field {
        margin-bottom: 0;
    }

    &__label {
        margin-right: 0 !important;
    }

    &__divider {
        width: 100%;
        height: 1px;
        background-color: #D4DBE3;
        margin: 12px 0;
    }

    &__days {
        font-size: 14px;
        color: #5D758D;
    }

    &__recommended {
        background: $primary;
        top: 3px;
        right: 3px;
        border-radius: 8px;
        font-size: 12px;
        font-weight: 700;
        color: #fff;
        position: absolute;
        align-items: center;
        padding: 4px;
    }
}
</style>